/**
* Created by ferto
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 16/03/2018.
*
* designer-answers-panel Component
*/
<template>
  <div class="designer-answers-panel">
    <form
      @submit.prevent="add"
      class="answer-form"
      v-if="questionType !== 'true_or_false' && questionType !== 'range'"
    >
      <el-input
        v-model.trim="name"
        placeholder="Escriba una respuesta"
      >
        <el-button
          slot="append"
          @click="add"
          icon="icon-add"
        />
      </el-input>
    </form>

    <div class="answers-list">
      <draggable :options="{handle: '.drag-handler'}">
        <div
          class="answer-item"
          v-for="(answer, $index) in value"
          :key="$index"
        >
          <header>
            <button class="drag-handler">
              <i class="icon-drag_handle"/>
            </button>
            <h6>
              {{ answer.name }}
            </h6>
            <div class="controls">
              <button
                @click="edit(answer)"
                class="btn btn-transparent"
                v-if="questionType !== 'true_or_false'"
              >
                <i class="icon-mode_edit"/>
              </button>
              <button
                @click="remove($event, $index)"
                v-if="questionType !== 'true_or_false'"
                class="btn btn-transparent"
              >
                <i class="icon-delete"/>
              </button>
              <button
                @click="toggle(answer)"
                class="btn btn-transparent"
              >
                <i
                  v-if="answer.$closed"
                  class="icon-expand_more"
                />
                <i
                  v-else
                  class="icon-expand_less"
                />
              </button>
            </div>
          </header>
          <main :class="{'closed':answer.$closed}">
            <div class="wrapper">
              <label>
                Evidencia requerida
                <el-switch
                  style="float: right"
                  v-model="answer.$evidenceRequired"
                />
              </label>
              <br>
              <br>
              <label>
                Puntaje por sucursal
                <el-switch
                  style="float: right"
                  @change="onPointsPerBranch($event, answer)"
                  v-model="answer.$pointsPerBranch"
                />
              </label>
              <div v-if="answer.$pointsPerBranch">
                <table class="table">
                  <thead>
                    <tr>
                      <th>N/A</th>
                      <th>Sucursal</th>
                      <th>Puntos</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(points, $index) in answer.$branchPoints"
                      :class="{disabled:points.$disabled}"
                      :key="$index"
                    >
                      <td>
                        <el-checkbox
                          v-model="points.$disabled"
                        />
                      </td>
                      <td class="text-center">
                        <span class="branch-type">{{ points.type }}</span>
                      </td>
                      <td>
                        <el-input-number
                          :disabled="points.$disabled"
                          :min="0"
                          size="small"
                          :step="10"
                          v-model.number="points.points"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                style="margin-top: 20px"
                v-else
              >
                <el-input-number
                  :min="0"
                  size="large"
                  :step="10"
                  v-model.number="answer.$points"
                />
              </div>
            </div>
          </main>
        </div>
      </draggable>
    </div>
  </div>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import Draggable from 'vuedraggable'
import id from '@/helpers/id'
export default {
  name: 'DesignerAnswersPanel',
  components: { Draggable },
  props: {
    branchTypes: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    questionType: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      required: true,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      name: ''
    }
  },
  watch: {
    value (n, o) {
      let $pristine = false
      for (let item of n) {
        if (!item.$branchPoints) {
          this.$set(item, '$branchPoints', [])
          this.$set(item, '$pointsPerBranch', false)
          this.$set(item, '$points', 0)
        }
        for (let branchType of this.branchTypes) {
          let current = {
            type: branchType,
            found: false
          }
          for (let point of item.$branchPoints) {
            if (point.type === current.type) {
              current.found = true
            }
          }
          if (!current.found) {
            item.$branchPoints.push({
              type: current.type,
              points: 0,
              $disabled: $pristine
            })
          }
        }
      }
    }
  },
  methods: {
    add () {
      if (this.name) {
        this.value.push({
          $id: id(),
          name: this.name,
          $branchPoints: [],
          $pointsPerBranch: false,
          $points: 0
        })
        this.name = ''
        this.$emit('input', this.value)
      }
    },
    edit (answer) {
      this.$prompt('Introduzca la nueva respuesta', 'Editar respuesta', {
        inputValue: answer.name
      }).then(response => {
        if (response.action === 'confirm') {
          answer.name = response.value
        }
      })
    },
    onPointsPerBranch (value, answer) {
      if (value) {
        answer.$points = 0
        answer.$branchPoints = []
        for (let branch of this.branchTypes) {
          answer.$branchPoints.push({
            type: branch,
            points: 0,
            $disabled: false
          })
        }
      } else {
        answer.$branchPoints = []
      }
    },
    remove (e, index) {
      this.$confirm('¿está seguro que desea eliminar esta respuesta?').then(
        () => {
          this.value.splice(index, 1)
          this.$emit('input', this.value)
        }
      )
    },
    toggle (answer) {
      if (answer.$closed === undefined) {
        this.$set(answer, '$closed', true)
      } else {
        answer.$closed = !answer.$closed
      }
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style
  lang="scss"
  scoped
>
.answer-form {
  margin: 20px;

  .input-group {
    input {
      border-radius: 2px 0 0 2px;
    }
    .input-group-append {
      button {
        height: 38px;
        border-radius: 0 2px 2px 0;
        border: 1px solid $color-ui-primary;
      }
    }
  }
}

.answers-list {
  margin: 20px;
  .answer-item {
    background-color: #ffffff;
    margin-bottom: 10px;
    border: 1px solid #dddddd;
    header {
      position: relative;
      .drag-handler {
        position: absolute;
        top: 0;
        left: 0;
        cursor: grab;
        &:active {
          cursor: grabbing;
        }
      }
      h6 {
        display: block;
        padding: 10px 10px;
        margin: 0;
        margin-left: 30px;
        padding-right: 100px;
        text-overflow: ellipsis;
      }
      .controls {
        text-align: right;
        position: absolute;
        top: 0;
        right: 0;
        button {
          width: 20px;
        }
      }
      button {
        width: 35px;
        height: 35px;
        display: inline-block;
        text-align: center;
        background-color: transparent;
        border: none;
        color: #999999;
      }
    }
    main {
      transition: all 0.6s ease-in-out;
      overflow: hidden;
      max-height: 10000px;
      &.closed {
        max-height: 0;
      }
      .wrapper {
        padding: 20px;
        overflow: hidden;
      }
    }
    .table {
      width: 100%;
      margin-bottom: 0;
      margin-top: 20px;
      tbody {
        tr {
          td {
            vertical-align: middle;
            text-align: center;
            .branch-type {
              color: $color-ui-primary;
              border: 1px solid $color-ui-primary;
              border-radius: 2px;
              text-align: center;
              display: inline-block;
              vertical-align: middle;
              padding: 4px;
              width: 18px;
              height: 18px;
              line-height: 18px;
            }
          }
          &.disabled {
            td {
              .branch-type {
                color: #999;
                border-color: #999;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/designer/_shared/designer-answers-panel.vue